(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["re-pair-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll("[data-re-pair-bundle]").forEach(function (wrap) {
      var container = wrap.closest(".re-pair-bundle-section");
      var script = container && container.querySelector("[data-re-pair-variants]");
      if (!script) return;
      var variants = JSON.parse(script.textContent);

      var button = wrap.querySelector("[data-re-pair-add]");
      var buttonText = wrap.querySelector("[data-re-pair-add-text]");
      if (!button) return;

      button.addEventListener("click", function () {
        var rightVariant = variants.find(function (v) {
          return v.options.some(function (o) { return /right/i.test(o); }) && v.available;
        });
        var leftVariant = variants.find(function (v) {
          return v.options.some(function (o) { return /left/i.test(o); }) && v.available;
        });

        if (!rightVariant || !leftVariant) {
          console.warn(
            "RE Pair Bundle: couldn't find available Right/Left variants. " +
            "Check that the product's option values contain \"Right\" and \"Left\"."
          );
          return;
        }

        if (buttonText) buttonText.textContent = "Adding...";
        button.disabled = true;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: [
              { id: rightVariant.id, quantity: 1 },
              { id: leftVariant.id, quantity: 1 },
            ],
          }),
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            if (buttonText) buttonText.textContent = "Added ✓";
            setTimeout(function () { window.location.reload(); }, 600);
          })
          .catch(function (err) {
            console.error("RE Pair Bundle: add to cart failed", err);
            if (buttonText) buttonText.textContent = "Try again";
            button.disabled = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["re2-drag-spin"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-re-dragspin]').forEach(function(stage){
      var canvas = stage.querySelector('[data-re-dragspin-canvas]');
      var hint = stage.querySelector('[data-re-dragspin-hint]');
      var ctx = canvas.getContext('2d');
      var section = stage.closest('section');
      var small = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      var srcs = [].slice.call(section.querySelectorAll('[data-frame]')).map(function(img){ return (small && img.getAttribute('data-sm')) || img.getAttribute('data-src'); });
      if (!srcs.length) return;

      var imgs = [], ok = [], anyReady = false, index = 0, started = false;
      function load(){
        if (started) return;
        started = true;
        srcs.forEach(function(src, i){
          var im = new Image();
          im.onload = function(){ ok[i] = true; if (!anyReady) { anyReady = true; resize(); } else { draw(); } };
          im.src = src;
          imgs[i] = im;
        });
      }

      function wrap(i){ return ((i % imgs.length) + imgs.length) % imgs.length; }
      function nearest(i){
        for (var d = 0; d < imgs.length; d++) {
          if (ok[wrap(i - d)]) return wrap(i - d);
          if (ok[wrap(i + d)]) return wrap(i + d);
        }
        return -1;
      }

      function draw(){
        if (!anyReady) return;
        var j = nearest(index);
        if (j < 0) return;
        var im = imgs[j];
        var dpr = window.devicePixelRatio || 1;
        var cw = canvas.width / dpr, ch = canvas.height / dpr;
        if (!cw || !ch) return;
        ctx.clearRect(0, 0, cw, ch);
        var scale = Math.max(cw / im.naturalWidth, ch / im.naturalHeight);
        var iw = im.naturalWidth * scale, ih = im.naturalHeight * scale;
        ctx.drawImage(im, (cw - iw) / 2, (ch - ih) / 2, iw, ih);
      }

      function resize(){
        var dpr = window.devicePixelRatio || 1;
        var w = stage.clientWidth, h = stage.clientHeight;
        if (w < 2 || h < 2) return;
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        draw();
      }

      var dragging = false, startX = 0, startIndex = 0;
      var PX_PER_FRAME = 9;

      function down(e){
        load();
        dragging = true;
        stage.classList.add('is-dragging');
        startX = e.clientX;
        startIndex = index;
        if (hint) hint.classList.add('is-hidden');
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      function move(e){
        if (!dragging) return;
        var delta = e.clientX - startX;
        index = startIndex - Math.round(delta / PX_PER_FRAME);
        draw();
      }
      function up(e){
        dragging = false;
        stage.classList.remove('is-dragging');
        try { stage.releasePointerCapture(e.pointerId); } catch (err) {}
      }

      stage.addEventListener('pointerdown', down);
      stage.addEventListener('pointermove', move);
      stage.addEventListener('pointerup', up);
      stage.addEventListener('pointercancel', up);

      window.addEventListener('resize', resize);
      if (window.ResizeObserver) new ResizeObserver(resize).observe(stage);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries){ if (entries[0].isIntersecting) { load(); io.disconnect(); } }, { rootMargin: '1000px 0px' });
        io.observe(stage);
      } else { load(); }
      resize();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["re2-scroll-spin"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-re-scrollspin]').forEach(function(section){
      var canvas = section.querySelector('[data-re-scrollspin-canvas]');
      var bar = section.querySelector('[data-re-scrollspin-bar]');
      var ctx = canvas.getContext('2d');
      var small = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      var srcs = [].slice.call(section.querySelectorAll('[data-frame]')).map(function(img){ return (small && img.getAttribute('data-sm')) || img.getAttribute('data-src'); });
      if (!srcs.length) return;
      var imgs = [], ok = [], anyReady = false, lastIndex = 0, started = false;

      /* Frames only download when the section is close to the screen, and phones get smaller files.
         Whatever has loaded is shown straight away (nearest frame), so the canvas is never blank. */
      function load(){
        if (started) return;
        started = true;
        srcs.forEach(function(src, i){
          var im = new Image();
          im.onload = function(){ ok[i] = true; if (!anyReady) { anyReady = true; resize(); } else { draw(lastIndex); } };
          im.src = src;
          imgs[i] = im;
        });
      }

      function nearest(i){
        for (var d = 0; d < imgs.length; d++) {
          if (ok[i - d]) return i - d;
          if (ok[i + d]) return i + d;
        }
        return -1;
      }

      function draw(i){
        if (!anyReady) return;
        lastIndex = Math.max(0, Math.min(imgs.length - 1, i));
        var j = nearest(lastIndex);
        if (j < 0) return;
        var im = imgs[j];
        var dpr = window.devicePixelRatio || 1;
        var cw = canvas.width / dpr, ch = canvas.height / dpr;
        if (!cw || !ch) return;
        ctx.clearRect(0, 0, cw, ch);
        var scale = Math.min(cw / im.naturalWidth, ch / im.naturalHeight);
        var iw = im.naturalWidth * scale, ih = im.naturalHeight * scale;
        ctx.drawImage(im, (cw - iw) / 2, (ch - ih) / 2, iw, ih);
      }

      function resize(){
        var dpr = window.devicePixelRatio || 1;
        var w = canvas.clientWidth, h = canvas.clientHeight;
        if (w < 2 || h < 2) return;
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        draw(lastIndex);
      }

      var ticking = false;
      function onScroll(){
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function(){
          var rect = section.getBoundingClientRect();
          var total = rect.height - window.innerHeight;
          var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
          draw(Math.round(progress * (imgs.length - 1)));
          if (bar) bar.style.setProperty('--p', Math.round(progress * 100) + '%');
          ticking = false;
        });
      }

      window.addEventListener('resize', function(){ resize(); onScroll(); });
      window.addEventListener('scroll', onScroll, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(resize).observe(canvas);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries){ if (entries[0].isIntersecting) { load(); io.disconnect(); } }, { rootMargin: '1400px 0px' });
        io.observe(section);
      } else { load(); }
      resize();
      onScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["re2-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var bar = document.querySelector('[data-re-satc]');
    if (!bar) return;
    var btn = bar.querySelector('[data-re-satc-btn]');
    var vEl = bar.querySelector('[data-re-satc-variant]');
    function submit(){ return document.querySelector('.product-form__submit'); }
    function variant(){ var i = document.querySelector('.product-form__input input[type=radio]:checked'); return i ? i.value : ''; }
    function update(){
      var s = submit();
      if (!s) return;
      var r = s.getBoundingClientRect();
      var phone = window.innerWidth < 750;
      /* Desktop: after the buy button scrolls away. Phones: from the first scroll, until the real button is on screen. */
      var on = r.bottom < 0 || (phone && window.scrollY > 60 && r.top > window.innerHeight - 24);
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.documentElement.style.setProperty('--satc-h', bar.offsetHeight + 'px');
      document.documentElement.classList.toggle('has-satc', on);
      if (vEl) { var v = variant(); vEl.textContent = v ? v + ' · ' : ''; }
    }
    btn.addEventListener('click', function(){ var s = submit(); if (s) s.click(); });
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('change', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-anatomy"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      var pins = [].slice.call(root.querySelectorAll('[data-pin]'));
      var items = [].slice.call(root.querySelectorAll('[data-item]'));
      if (!pins.length) return;
      var cur = 1, timer = 0, stopped = false;
      function show(n){
        cur = n;
        pins.forEach(function(p){ p.classList.toggle('is-on', parseInt(p.getAttribute('data-pin'), 10) === n); });
        items.forEach(function(i){ i.classList.toggle('is-on', parseInt(i.getAttribute('data-item'), 10) === n); });
      }
      function stop(){ stopped = true; if (timer) { clearInterval(timer); timer = 0; } }
      pins.forEach(function(p){ p.addEventListener('click', function(){ stop(); show(parseInt(p.getAttribute('data-pin'), 10)); }); });
      items.forEach(function(i){
        function pick(){ stop(); show(parseInt(i.getAttribute('data-item'), 10)); }
        i.addEventListener('click', pick);
        i.addEventListener('mouseenter', function(){ if (window.matchMedia && window.matchMedia('(hover:hover)').matches) pick(); });
        i.addEventListener('focus', pick);
      });
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.isIntersecting && !stopped && !timer) timer = setInterval(function(){ show(cur >= pins.length ? 1 : cur + 1); }, 4200);
          else if (!e.isIntersecting && timer) { clearInterval(timer); timer = 0; }
        });
      }, { threshold: 0.4 }).observe(root);
    }
    function boot(){ [].forEach.call(document.querySelectorAll('[data-rx-anatomy]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-article"]) return;
  try {
    
  (function () {
    function init() {
      var prose = document.querySelector('[data-rx-prose]');
      var toc = document.querySelector('.rx-toc');
      if (!prose || !toc) return;
      var heads = prose.querySelectorAll('h2');
      if (heads.length < 3) return;
      var used = {};
      var items = [];
      heads.forEach(function (h, i) {
        var base = (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48) || ('section-' + (i + 1));
        var id = base, n = 2;
        while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
        used[id] = 1;
        if (!h.id) h.id = id;
        items.push('<li><a href="#' + h.id + '">' + h.textContent.replace(/</g, '&lt;') + '</a></li>');
      });
      toc.innerHTML = '<p class="rx-toc__t">In this article</p><ol>' + items.join('') + '</ol>';
      toc.hidden = false;
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-boxset"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      var pins = [].slice.call(root.querySelectorAll('[data-pin]'));
      var items = [].slice.call(root.querySelectorAll('[data-item]'));
      if (!pins.length) return;
      var cur = 1, timer = 0, stopped = false;
      function show(n){
        cur = n;
        pins.forEach(function(p){ p.classList.toggle('is-on', parseInt(p.getAttribute('data-pin'), 10) === n); });
        items.forEach(function(i){ i.classList.toggle('is-on', parseInt(i.getAttribute('data-item'), 10) === n); });
      }
      function stop(){ stopped = true; if (timer) { clearInterval(timer); timer = 0; } }
      pins.forEach(function(p){ p.addEventListener('click', function(){ stop(); show(parseInt(p.getAttribute('data-pin'), 10)); }); });
      items.forEach(function(i){
        function pick(){ stop(); show(parseInt(i.getAttribute('data-item'), 10)); }
        i.addEventListener('click', pick);
        i.addEventListener('mouseenter', function(){ if (window.matchMedia && window.matchMedia('(hover:hover)').matches) pick(); });
        i.addEventListener('focus', pick);
      });
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.isIntersecting && !stopped && !timer) timer = setInterval(function(){ show(cur >= pins.length ? 1 : cur + 1); }, 3800);
          else if (!e.isIntersecting && timer) { clearInterval(timer); timer = 0; }
        });
      }, { threshold: 0.4 }).observe(root);
    }
    function boot(){ [].forEach.call(document.querySelectorAll('[data-rx-boxset]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-bundle"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      var radios = root.querySelectorAll('input[type="radio"]');
      var btn = root.querySelector('.rx-sel__add');
      var imgs = root.querySelectorAll('.rx-sel__img');
      var note = root.querySelector('.rx-sel__note');
      var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
      var setImg = root.querySelector('[data-thumb="set"] img');
      var cur = 'pair';
      function show(opt){
        [].forEach.call(imgs, function(i){ i.classList.toggle('is-on', i.getAttribute('data-opt') === opt); });
        thumbs.forEach(function(t){ var k = t.getAttribute('data-thumb'); t.classList.toggle('is-on', k === 'set' ? opt === cur : k === opt); });
      }
      function apply(r){
        cur = r.value;
        [].forEach.call(root.querySelectorAll('.rx-opt'), function(o){ o.classList.toggle('is-on', o.contains(r)); });
        if (setImg && setImg.getAttribute('data-' + cur)) setImg.src = setImg.getAttribute('data-' + cur);
        show(cur);
        if (btn) { btn.setAttribute('data-rx-add', r.getAttribute('data-ids')); btn.textContent = r.getAttribute('data-label'); }
        if (note) note.hidden = r.value !== 'pair';
      }
      thumbs.forEach(function(t){ t.addEventListener('click', function(){ var k = t.getAttribute('data-thumb'); show(k === 'set' ? cur : k); }); });
      [].forEach.call(radios, function(r){ r.addEventListener('change', function(){ apply(r); }); });
    }
    function initSticky(){
      var bar = document.querySelector('[data-rx-sticky]');
      var root = document.querySelector('[data-rx-sel]');
      if (!bar || !root) return;
      var main = root.querySelector('.rx-sel__add');
      var btn = bar.querySelector('.rx-sticky__btn');
      var label = bar.querySelector('.rx-sticky__label');
      var price = bar.querySelector('.rx-sticky__price');
      if (!main || !btn) return;
      document.body.classList.add('rx-has-sticky');
      function sync(){
        var on = root.querySelector('.rx-opt.is-on');
        if (on) {
          var t = on.querySelector('.rx-opt__txt strong');
          var pb = on.querySelector('.rx-opt__price b');
          var ps = on.querySelector('.rx-opt__price s');
          if (t && label) label.textContent = t.textContent;
          if (price) price.innerHTML = pb ? '<b>' + pb.textContent + '</b>' + (ps ? ' <s>' + ps.textContent + '</s>' : '') : '';
        }
        btn.setAttribute('data-rx-add', main.getAttribute('data-rx-add') || '');
        btn.disabled = main.disabled;
        btn.textContent = main.disabled ? 'Not available in your country' : (main.textContent || 'Add to cart').replace(/ to cart$/, '');
      }
      [].forEach.call(root.querySelectorAll('input[type="radio"]'), function(r){ r.addEventListener('change', function(){ setTimeout(sync, 0); }); });
      /* Show the bar whenever the real Add to cart button is off screen. */
      function update(){
        var r = main.getBoundingClientRect();
        bar.classList.toggle('is-on', r.bottom < 0 || r.top > window.innerHeight);
      }
      var ticking = false;
      function onMove(){ if (ticking) return; ticking = true; requestAnimationFrame(function(){ ticking = false; update(); }); }
      window.addEventListener('scroll', onMove, { passive: true });
      window.addEventListener('resize', onMove);
      sync();
      update();
    }
    function boot(){ [].forEach.call(document.querySelectorAll('[data-rx-sel]'), init); initSticky(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-cart"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function change(key, qty){
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function(r){ if (!r.ok) throw new Error('x'); return r.json(); })
        .then(function(){ window.location.reload(); });
    }
    document.addEventListener('click', function(e){
      var b = e.target.closest('[data-rx-cart] [data-qty]');
      if (!b) return;
      e.preventDefault();
      var cur = parseInt(b.getAttribute('data-cur'), 10) || 0;
      b.disabled = true;
      change(b.getAttribute('data-key'), Math.max(0, cur + parseInt(b.getAttribute('data-qty'), 10))).catch(function(){ b.disabled = false; });
    });
    document.addEventListener('change', function(e){
      var i = e.target.closest('[data-rx-cart] .rx-cart__qty input');
      if (!i) return;
      var q = parseInt(i.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      change(i.getAttribute('data-key'), q).catch(function(){});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-design"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var phone = window.matchMedia('(max-width: 749px)');
    var PIN_ON_PHONE = false; /* true = page scroll drives the row on phones; false = plain swipe */
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    function init(sec){
      var track = sec.querySelector('[data-rxd-track]');
      var pin = sec.querySelector('[data-rxd-pin]');
      var row = sec.querySelector('[data-rxd-row]');
      if (!track || !pin || !row) return;
      var cards = [].slice.call(row.children);
      var dots = [].slice.call(sec.querySelectorAll('[data-rxd-go]'));
      var n = cards.length;
      if (n < 2) return;
      if (!window.CSS || !CSS.supports || !CSS.supports('position', 'sticky')) return;
      var on = false, last = -1, topOff = 8, total = 0, pitchPx = 316;
      function mark(i){
        if (i === last) return;
        last = i;
        cards.forEach(function(c, k){ c.classList.toggle('is-active', k === i); });
        dots.forEach(function(d, k){ d.classList.toggle('is-active', k === i); });
      }
      function measure(){
        track.style.setProperty('--pin-h', pin.offsetHeight + 'px');
        track.style.setProperty('--steps', n - 1);
        topOff = parseFloat(getComputedStyle(pin).top) || 0;
        total = track.offsetHeight - pin.offsetHeight;
        pitchPx = cards[0].offsetWidth + (parseFloat(getComputedStyle(row).columnGap) || 16);
      }
      function update(){
        if (!on) return;
        var p = total > 0 ? (topOff - track.getBoundingClientRect().top) / total : 0;
        p = Math.min(1, Math.max(0, p));
        row.scrollLeft = p * (n - 1) * pitchPx;
        mark(Math.round(p * (n - 1)));
      }
      function enable(){ on = true; last = -1; sec.classList.add('is-pin'); measure(); update(); }
      function disable(){ on = false; last = -1; sec.classList.remove('is-pin'); track.style.removeProperty('--pin-h'); track.style.removeProperty('--steps'); row.scrollLeft = 0; mark(0); }
      function sync(){
        if (PIN_ON_PHONE && phone.matches && !calm.matches) { if (!on) enable(); else { measure(); update(); } }
        else if (on) disable();
      }
      dots.forEach(function(d){
        d.addEventListener('click', function(){
          var i = parseInt(d.getAttribute('data-rxd-go'), 10) || 0;
          if (on) {
            var y = window.scrollY + track.getBoundingClientRect().top - topOff + (i / (n - 1)) * total;
            window.scrollTo({ top: y, behavior: 'smooth' });
          } else {
            row.scrollTo({ left: i * (cards[0].offsetWidth + 16), behavior: 'smooth' });
          }
        });
      });
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', sync);
      window.addEventListener('orientationchange', sync);
      if (phone.addEventListener) { phone.addEventListener('change', sync); calm.addEventListener('change', sync); }
      if ('ResizeObserver' in window) new ResizeObserver(function(){ if (on) { measure(); update(); } }).observe(pin);
      row.addEventListener('scroll', function(){ if (!on) mark(Math.min(n - 1, Math.round(row.scrollLeft / (cards[0].offsetWidth + 16)))); }, { passive: true });
      sync();
    }
    function boot(){ [].forEach.call(document.querySelectorAll('.rxd'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-explore"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    function initPanel(p){
      var track = p.querySelector('[data-track]');
      var slides = [].slice.call(track.children);
      var thumbs = [].slice.call(p.querySelectorAll('[data-thumb]'));
      var cur = p.querySelector('[data-cur]');
      var ttl = p.querySelector('[data-title]');
      var txt = p.querySelector('[data-text]');
      var prev = p.querySelector('[data-dir="-1"]');
      var next = p.querySelector('[data-dir="1"]');
      var idx = -1, lock = 0;
      function show(i){
        if (i === idx) return;
        idx = i;
        var s = slides[i];
        cur.textContent = i + 1;
        ttl.textContent = s.getAttribute('data-ttl') || '';
        txt.textContent = s.getAttribute('data-txt') || '';
        thumbs.forEach(function(t, k){ t.classList.toggle('is-on', k === i); });
        prev.disabled = i === 0;
        next.disabled = i === slides.length - 1;
      }
      function go(i){
        i = Math.max(0, Math.min(slides.length - 1, i));
        lock = Date.now() + 600;
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        show(i);
      }
      track.addEventListener('scroll', function(){
        if (Date.now() < lock) return;
        var w = track.clientWidth;
        if (!w) return;
        show(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))));
      }, { passive: true });
      thumbs.forEach(function(t, k){ t.addEventListener('click', function(){ go(k); }); });
      prev.addEventListener('click', function(){ go(idx - 1); });
      next.addEventListener('click', function(){ go(idx + 1); });
      p.rxReset = function(){ track.scrollLeft = 0; idx = -1; show(0); };
      show(0);
    }
    function init(root){
      var tabs = [].slice.call(root.querySelectorAll('[data-tab]'));
      var panels = [].slice.call(root.querySelectorAll('[data-panel]'));
      panels.forEach(initPanel);
      tabs.forEach(function(t){
        t.addEventListener('click', function(){
          var n = parseInt(t.getAttribute('data-tab'), 10);
          tabs.forEach(function(x){
            var on = x === t;
            x.classList.toggle('is-on', on);
            x.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function(p){
            var on = parseInt(p.getAttribute('data-panel'), 10) === n;
            p.hidden = !on;
            if (on && p.rxReset) p.rxReset();
          });
        });
      });
    }
    function boot(){ [].forEach.call(document.querySelectorAll('[data-rx-explore]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-faq"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function merge(){
      var tags = [].slice.call(document.querySelectorAll('script[type="application/ld+json"][data-rx-faq]'));
      if (tags.length < 2) return;
      var all = [];
      tags.forEach(function(t){ try { var d = JSON.parse(t.textContent); (d.mainEntity || []).forEach(function(q){ all.push(q); }); } catch (e) {} });
      if (!all.length) return;
      tags[0].textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: all });
      tags.slice(1).forEach(function(t){ if (t.parentNode) t.parentNode.removeChild(t); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', merge); } else { merge(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    /* Big screens: the full-width hero plays the 1080p file so it stays sharp (phones and slow connections keep the lighter files). */
    function up(){
      if (window.innerWidth < 1600) return; /* speed: only very large screens swap to the 1080p file */
      var c = {}; try { c = navigator.connection || {}; } catch (e) {}
      if (c.saveData || /^(slow-2g|2g|3g)$/.test(c.effectiveType || '')) return;
      var v = document.querySelector('.rx-hero video'); if (!v) return;
      var hi = '';
      [].slice.call(v.querySelectorAll('source')).forEach(function(s){ if (/HD-1080p/.test(s.src)) hi = s.src; });
      if (!hi || v.getAttribute('src') === hi) return;
      var was = v.getAttribute('data-rx-in') === '1';
      v.src = hi; v.load();
      if (was) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', up); else up();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-inflate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Frame sets cut from the real timelapse video. The numbers are frame numbers in the source video. Phones get a lighter set. */
    var SETS = {
      d: { w: 1440, h: 682, src: [80,84,88,92,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,154,156,158,160,162,164,166,168,170,172,174,176,178,180,182,184,186,188,190,192,194,196,198,200,202,204,206,208,680,952,962,972,982,992,1002,1012,1022,1032,1042,1052,1062,1072,1082,1092] },
      m: { w: 1080, h: 512, src: [80,84,88,92,96,100,104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,680,952,972,992,1012,1032,1052,1072,1092] }
    };
    var LABELS = ['Ready', 'Calf fills', 'Thigh fills', 'Release'];
    var KEYS = { calf: [[79, 40], [80, 24], [79, 40]], thigh: [[15, 50], [13, 54], [15, 54]], knee: [[50, 42], [57, 19], [53, 38]] };   /* pin positions in percent: flat, inflated, released */

    function init(root) {
      if (root.__rxi) return; root.__rxi = true;
      var q = function (s) { return root.querySelector(s); };
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var conn = navigator.connection || {};
      var lean = !!(conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''));
      var SMALL = (window.matchMedia && matchMedia('(max-width: 749px)').matches) || !!conn.saveData;
      var S = SMALL ? SETS.m : SETS.d, SRC = S.src, N = SRC.length, LAST = N - 1, HOLD = SRC.indexOf(680), DWELL = 1100;
      var URLS = [];
      try { URLS = JSON.parse(root.getAttribute(SMALL ? 'data-m' : 'data-d')) || []; } catch (e) {}
      if (URLS.length !== N) return;   /* frames missing: leave the still picture in place */
      var autoOk = root.getAttribute('data-autoplay') !== 'false';

      function idxOf(f) { var b = 0; for (var i = 1; i < N; i++) if (Math.abs(SRC[i] - f) < Math.abs(SRC[b] - f)) b = i; return b; }
      var DUR = SRC.map(function (f, i) {   /* how long each step lasts while playing, in ms */
        if (i >= LAST) return 1;
        if (i >= HOLD) return i === HOLD ? 330 : 140;
        return Math.max(70, Math.min(330, (SRC[i + 1] - f) * 41.7));
      });
      var CUT = SRC.map(function (f, i) { return i < LAST && SRC[i + 1] - f > 40; });   /* big jumps in the footage are cut, never blended */
      var JUMPS = [0, idxOf(112), idxOf(177), idxOf(1018)];
      var TEXTS = [0, 1, 2, 3].map(function (i) { return root.getAttribute('data-cap' + i) || ''; });

      var stage = q('[data-r="stage"]'), cv = q('[data-r="cv"]'), ctx = cv.getContext('2d'), poster = q('[data-r="poster"]');
      var cover = q('[data-r="cover"]'), coverTxt = q('[data-r="cover-txt"]'), loadbar = q('[data-r="loadbar"]');
      var cap = q('[data-r="cap"]'), capB = q('[data-r="cap-b"]'), capT = q('[data-r="cap-t"]');
      var playBtn = q('[data-r="play"]'), playTxt = q('[data-r="play-txt"]'), playIco = q('[data-r="play-ico"]'), slider = q('[data-r="slider"]');
      var stepBtns = [].slice.call(root.querySelectorAll('.rxi__steps button'));
      var pins = {}; [].forEach.call(root.querySelectorAll('.rxi__pin'), function (el) { pins[el.getAttribute('data-zone')] = el; });
      var zones = {}; [].forEach.call(root.querySelectorAll('.rxi__zone'), function (el) { zones[el.getAttribute('data-zone')] = el; });
      cv.width = S.w; cv.height = S.h;
      if (poster.complete && poster.naturalWidth) stage.classList.add('has-poster');

      var imgs = new Array(N), p = 0, mode = 'idle', last = 0, raf = 0, tween = null, step = -1, holdLeft = 0, passedHold = false;
      var started = false, ready = false, busy = false, failed = false, forced = false, loaded = 0, fillLoaded = 0, readyTimer = 0, active = 0;
      var userTouched = false, autoDone = false, wantPlay = false, wantAuto = false, inView = false;

      function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
      function srcPos(v) { var i = clamp(Math.floor(v), 0, LAST), j = Math.min(LAST, i + 1); return SRC[i] + (SRC[j] - SRC[i]) * (v - i); }

      /* ---------- loading ---------- */
      var ORDER = (function () {
        var seen = {}, out = [];
        function add(i) { if (i >= 0 && i < N && !seen[i]) { seen[i] = 1; out.push(i); } }
        [0, HOLD, LAST].forEach(add);
        [32, 16, 8, 4, 2, 1].forEach(function (st) { for (var i = 0; i <= HOLD; i += st) add(i); });
        for (var i = HOLD + 1; i < N; i++) add(i);
        return out;
      })();
      var queue = ORDER.slice();
      function load() {
        if (started) return; started = true;
        readyTimer = setTimeout(function () { forced = true; check(); }, 8000);
        pump();
      }
      function pump() { while (active < 6 && queue.length) fetchOne(queue.shift()); }
      function fetchOne(i) {
        active++;
        var im = new Image(), done = false;
        function fin(ok) {
          if (done) return; done = true; active--;
          imgs[i] = ok ? im : null; loaded++; if (i <= HOLD) fillLoaded++;
          loadbar.style.width = Math.round(loaded / N * 100) + '%';
          if (loaded === N) loadbar.classList.add('is-done');
          if (i === 0 || Math.abs(i - p) < 1.5) draw();
          check(); pump();
        }
        im.onload = function () {
          if (!im.decode) return fin(true);
          var t = setTimeout(function () { fin(true); }, 1500);
          im.decode().then(function () { clearTimeout(t); fin(true); }, function () { clearTimeout(t); fin(true); });
        };
        im.onerror = function () { fin(false); };
        im.src = URLS[i];
      }
      function check() {
        if (ready || failed) return;
        if (fillLoaded > HOLD || forced) { if (!nearest(0)) fail(); else setReady(); }
      }
      function setReady() {
        ready = true; clearTimeout(readyTimer); if (busy) setBusy(false);
        if (wantPlay) { wantPlay = false; startPlay(); }
        else if (wantAuto && inView && !userTouched) { wantAuto = false; autoDone = true; startPlay(); }
      }
      function setBusy(on) { busy = on; coverTxt.textContent = on ? 'Loading…' : 'Play the footage'; playBtn.setAttribute('aria-busy', on ? 'true' : 'false'); sync(); }
      function fail() {
        failed = ready = true; wantPlay = wantAuto = false; busy = false; clearTimeout(readyTimer);
        cover.hidden = true; Object.keys(pins).forEach(function (k) { pins[k].hidden = true; });
        capB.textContent = 'Footage unavailable'; capT.textContent = 'The footage could not be loaded. Please refresh the page.';
      }
      function nearest(i) { for (var d = 0; d < N; d++) { if (imgs[i - d]) return imgs[i - d]; if (imgs[i + d]) return imgs[i + d]; } return null; }

      /* ---------- drawing ---------- */
      function draw() {
        var pp = clamp(p, 0, LAST); if (pp !== pp) return;
        var a = Math.floor(pp), b = Math.min(LAST, a + 1), f = pp - a;
        f = CUT[a] ? (f < .5 ? 0 : 1) : clamp((f - .25) / .5, 0, 1);   /* blend only through the middle of each step */
        var ia = nearest(a), ib = nearest(b); if (!ia) return;
        ctx.globalAlpha = 1; ctx.drawImage(f >= 1 && ib ? ib : ia, 0, 0, cv.width, cv.height);
        if (f > 0 && f < 1 && ib && ib !== ia) { ctx.globalAlpha = f; ctx.drawImage(ib, 0, 0, cv.width, cv.height); ctx.globalAlpha = 1; }
        stage.classList.add('is-ready');
      }
      function lerp(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]; }
      function placePins(pp, sp) {
        var a = pp <= HOLD ? clamp((sp - 80) / 45, 0, 1) : 1, r = pp > HOLD ? clamp((sp - 952) / 138, 0, 1) : 0;
        Object.keys(KEYS).forEach(function (k) {
          var K = KEYS[k], c = lerp(lerp(K[0], K[1], a), K[2], r);
          pins[k].style.left = c[0].toFixed(2) + '%'; pins[k].style.top = c[1].toFixed(2) + '%';
        });
      }
      function stepOf(pp, sp) { return sp < 84 && pp <= HOLD ? 0 : sp < 133 && pp <= HOLD ? 1 : pp <= HOLD ? 2 : 3; }
      function sync() {
        var pp = clamp(p, 0, LAST), sp = srcPos(pp), s = stepOf(pp, sp), pct = pp / LAST * 100;
        slider.value = Math.round(pct * 10); slider.style.setProperty('--pct', pct + '%');
        placePins(pp, sp);
        if (s !== step) {
          step = s; stage.setAttribute('data-step', s);
          capB.textContent = LABELS[s]; capT.textContent = TEXTS[s];
          stepBtns.forEach(function (b, i) { if (i === s) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current'); });
          slider.setAttribute('aria-valuetext', LABELS[s]);
          pins.calf.classList.toggle('is-on', s === 1 || s === 2); pins.thigh.classList.toggle('is-on', s === 2);
          zones.calf.classList.toggle('is-on', s === 1 || s === 2); zones.thigh.classList.toggle('is-on', s === 2);
          pins.knee.classList.toggle('is-warm', s < 3);
        }
        var label = busy ? 'Loading…' : mode === 'play' ? 'Pause' : (pp >= LAST - .01 ? 'Replay' : 'Play');
        if (playTxt.textContent !== label) {
          playTxt.textContent = label;
          playIco.setAttribute('d', mode === 'play' ? 'M5 3.5h4.5v15H5zM12.5 3.5H17v15h-4.5z' : (pp >= LAST - .01 ? 'M11 3.5a7.5 7.5 0 1 0 7.2 9.5h-2.4A5.2 5.2 0 1 1 11 5.8V9l5-4.2L11 .6z' : 'M6 3.5v15l12-7.5z'));
        }
      }

      /* ---------- playback: one loop, three modes (idle, play, tween) ---------- */
      function schedule() { if (!raf) raf = requestAnimationFrame(frame); }
      function run() { last = 0; schedule(); }
      function frame(ts) {
        raf = 0; if (!last) last = ts;
        var dt = clamp(ts - last, 0, 100); last = ts;
        if (mode === 'play') {
          if (holdLeft > 0) holdLeft -= dt;
          else {
            p += dt / DUR[clamp(Math.floor(p), 0, N - 2)];
            if (!passedHold && p >= HOLD) { p = HOLD; passedHold = true; holdLeft = DWELL; }
            if (p >= LAST) { p = LAST; mode = 'idle'; }
          }
        } else if (mode === 'tween') {
          if (!tween.t0) tween.t0 = ts;
          var k = clamp((ts - tween.t0) / tween.ms, 0, 1), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
          p = tween.from + (tween.to - tween.from) * e; if (k >= 1) mode = 'idle';
        }
        draw(); sync();
        if (mode !== 'idle') schedule();
      }
      function hideCover() { if (cover.hidden) return; var had = document.activeElement === cover; cover.hidden = true; if (had) playBtn.focus(); }
      function startPlay() {
        if (!ready) { wantPlay = true; setBusy(true); load(); return; }
        hideCover();
        if (!(p >= 0) || p >= LAST - .01) p = 0;
        passedHold = p >= HOLD; holdLeft = 0; mode = 'play'; run();
      }
      function pause() { if (mode === 'play') { mode = 'idle'; sync(); } }
      function goTo(v) {
        userTouched = true; wantPlay = wantAuto = false; hideCover(); load();
        if (reduce) { mode = 'idle'; p = v; draw(); sync(); return; }
        if (Math.abs(v - p) < .01) return;
        tween = { from: p, to: v, t0: 0, ms: clamp(Math.abs(v - p) * 14, 350, 900) }; mode = 'tween'; run();
      }

      playBtn.addEventListener('click', function () { userTouched = true; if (busy) return; if (mode === 'play') pause(); else startPlay(); });
      cover.addEventListener('click', function () { userTouched = true; if (!busy) startPlay(); });
      stepBtns.forEach(function (b, i) { b.addEventListener('click', function () { goTo(JUMPS[i]); }); });
      slider.addEventListener('input', function () {
        userTouched = true; wantPlay = wantAuto = false; mode = 'idle'; hideCover(); load();
        p = slider.value / 1000 * LAST; draw(); sync();
      });

      /* keep the controls from moving when the caption changes height */
      function fitCap() {
        var h = 0, probe = cap.cloneNode(true);
        probe.removeAttribute('aria-live'); probe.setAttribute('aria-hidden', 'true');
        probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;min-height:0;width:' + cap.offsetWidth + 'px';
        cap.parentNode.appendChild(probe);
        TEXTS.forEach(function (t, i) { probe.firstChild.textContent = LABELS[i]; probe.lastChild.textContent = t; h = Math.max(h, probe.offsetHeight); });
        cap.parentNode.removeChild(probe); cap.style.minHeight = h + 'px';
      }
      var rt = 0; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fitCap, 150); });
      fitCap(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitCap);

      /* start loading when close, autoplay once when mostly on screen */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es, o) { if (es[es.length - 1].isIntersecting) { if (!lean) load(); o.disconnect(); } }, { rootMargin: '500px 0px' }).observe(stage);
        new IntersectionObserver(function (es) {
          inView = es[es.length - 1].isIntersecting;
          if (inView && autoOk && !autoDone && !userTouched && !reduce && !lean) { if (ready) { autoDone = true; startPlay(); } else { wantAuto = true; load(); } }
        }, { threshold: 0.6 }).observe(stage);
      } else if (!lean) { load(); }
      sync();
    }

    function boot(scope) { [].forEach.call((scope || document).querySelectorAll('[data-rxi]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-onperson"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Overlay on the photo: soft glows and inward arrows on each air section (percent of the picture). */
    var SECTIONS = [
      { k: 'calf',  cx: 21.3, cy: 51, rx: 11, ry: 11 }, { k: 'calf',  cx: 84.6, cy: 51, rx: 10, ry: 11 },
      { k: 'thigh', cx: 27.2, cy: 15, rx: 11, ry: 6 },  { k: 'thigh', cx: 76.5, cy: 14, rx: 12, ry: 6 }
    ];
    var KNEES = [{ cx: 25.7, cy: 30, rx: 13, ry: 7.5 }, { cx: 82.4, cy: 29, rx: 12, ry: 7.5 }];
    var Y = 1.0333, NS = 'http://www.w3.org/2000/svg';

    /* Footage: the same frames as the "Watch it inflate" section (cut from the real timelapse), so they are already cached when that section was seen. Phones get the lighter set. */
    var SETS = {
      d: { w: 1440, h: 682, src: [80,84,88,92,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,154,156,158,160,162,164,166,168,170,172,174,176,178,180,182,184,186,188,190,192,194,196,198,200,202,204,206,208,680,952,962,972,982,992,1002,1012,1022,1032,1042,1052,1062,1072,1082,1092] },
      m: { w: 1080, h: 512, src: [80,84,88,92,96,100,104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,680,952,972,992,1012,1032,1052,1072,1092] }
    };
    var LABELS = ['Ready', 'Calf fills', 'Thigh joins in', 'Air releases'];
    var KEYS = { calf: [[79, 40], [80, 24], [79, 40]], thigh: [[15, 50], [13, 54], [15, 54]], knee: [[50, 42], [57, 19], [53, 38]] };   /* pin positions in percent: flat, inflated, released */

    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function lerp(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]; }

    function overlay(root) {
      var uid = root.getAttribute('data-uid') || 'x', g = root.querySelector('[data-r="ov"]');
      if (!g) return;
      function el(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); (p || g).appendChild(e); return e; }
      KNEES.forEach(function (s) { el('ellipse', { cx: s.cx, cy: s.cy * Y, rx: s.rx, ry: s.ry * Y, fill: 'url(#rxo-gh-' + uid + ')', 'class': 'rxo__glow rxo__glow--heat' }); });
      SECTIONS.forEach(function (s) {
        var t = s.k === 'thigh', cy = s.cy * Y;
        el('ellipse', { cx: s.cx, cy: cy, rx: s.rx, ry: s.ry * Y, fill: 'url(#rxo-gb-' + uid + ')', 'class': 'rxo__glow' + (t ? ' rxo__glow--thigh' : '') });
        [['l', s.cx - s.rx * 0.95, 1], ['r', s.cx + s.rx * 0.95, -1]].forEach(function (a) {
          var x = a[1], d = a[2], path = 'M' + (x - 1.5 * d) + ' ' + (cy - 2.4) + ' L' + (x + 0.7 * d) + ' ' + cy + ' L' + (x - 1.5 * d) + ' ' + (cy + 2.4);
          var grp = el('g', { 'class': 'rxo__arr-' + a[0] + (t ? ' rxo__arr-t' : '') });
          el('path', { d: path, 'class': 'rxo__arr rxo__arr--under' }, grp); el('path', { d: path, 'class': 'rxo__arr rxo__arr--over' }, grp);
        });
      });
    }

    /* Footage card: loops the timelapse (calf fills, thigh joins, both hold, release) while it is on screen, with the numbered dots following each section. */
    function player(root) {
      var q = function (s) { return root.querySelector(s); };
      var cv = q('[data-r="cv"]'), poster = q('[data-r="poster"]'), clip = q('[data-r="clip"]'), live = q('[data-r="live"]');
      if (!cv || !clip) return;
      var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      var conn = {}; try { conn = navigator.connection || {}; } catch (e) {}
      var SMALL = (window.matchMedia && matchMedia('(max-width: 749px)').matches) || !!conn.saveData;
      var S = SMALL ? SETS.m : SETS.d, SRC = S.src, N = SRC.length, LAST = N - 1, HOLD = SRC.indexOf(680), DWELL = 1100, REST = 900;
      var URLS = [];
      try { URLS = JSON.parse(root.getAttribute(SMALL ? 'data-m' : 'data-d')) || []; } catch (e) {}
      if (URLS.length !== N) return;   /* frames missing: the still picture stays */
      var ctx = cv.getContext('2d'); cv.width = S.w; cv.height = S.h;
      var pins = {}; [].forEach.call(root.querySelectorAll('.rxo__pin'), function (e) { pins[e.getAttribute('data-zone')] = e; });
      var badges = {}; [].forEach.call(root.querySelectorAll('.rxo__live i'), function (e) { badges[e.getAttribute('data-b')] = e; });

      function idxOf(f) { var b = 0; for (var i = 1; i < N; i++) if (Math.abs(SRC[i] - f) < Math.abs(SRC[b] - f)) b = i; return b; }
      var DUR = SRC.map(function (f, i) {   /* how long each step lasts, in ms */
        if (i >= LAST) return 1;
        if (i >= HOLD) return i === HOLD ? 330 : 140;
        return Math.max(70, Math.min(330, (SRC[i + 1] - f) * 41.7));
      });
      var CUT = SRC.map(function (f, i) { return i < LAST && SRC[i + 1] - f > 40; });   /* big jumps in the footage are cut, never blended */

      var imgs = new Array(N), loaded = 0, active = 0, started = false, ready = false, timer = 0;
      var p = 0, last = 0, raf = 0, visible = false, passedHold = false, holdLeft = 0, atEnd = false, step = -1;

      function nearest(i) { for (var d = 0; d < N; d++) { if (imgs[i - d]) return imgs[i - d]; if (imgs[i + d]) return imgs[i + d]; } return null; }
      function srcPos(v) { var i = clamp(Math.floor(v), 0, LAST), j = Math.min(LAST, i + 1); return SRC[i] + (SRC[j] - SRC[i]) * (v - i); }
      function draw() {
        var pp = clamp(p, 0, LAST); if (pp !== pp) return;
        var a = Math.floor(pp), b = Math.min(LAST, a + 1), f = pp - a;
        f = CUT[a] ? (f < .5 ? 0 : 1) : clamp((f - .25) / .5, 0, 1);   /* blend only through the middle of each step */
        var ia = nearest(a), ib = nearest(b); if (!ia) return;
        ctx.globalAlpha = 1; ctx.drawImage(f >= 1 && ib ? ib : ia, 0, 0, cv.width, cv.height);
        if (f > 0 && f < 1 && ib && ib !== ia) { ctx.globalAlpha = f; ctx.drawImage(ib, 0, 0, cv.width, cv.height); ctx.globalAlpha = 1; }
        clip.classList.add('is-ready');
      }
      function sync() {
        var pp = clamp(p, 0, LAST), sp = srcPos(pp);
        var a = pp <= HOLD ? clamp((sp - 80) / 45, 0, 1) : 1, r = pp > HOLD ? clamp((sp - 952) / 138, 0, 1) : 0;
        Object.keys(KEYS).forEach(function (k) {
          var K = KEYS[k], c = lerp(lerp(K[0], K[1], a), K[2], r);
          if (pins[k]) { pins[k].style.left = c[0].toFixed(2) + '%'; pins[k].style.top = c[1].toFixed(2) + '%'; }
        });
        var s = sp < 84 && pp <= HOLD ? 0 : sp < 133 && pp <= HOLD ? 1 : pp <= HOLD ? 2 : 3;
        if (s === step) return; step = s;
        if (live) live.textContent = LABELS[s];
        if (pins.calf) pins.calf.classList.toggle('is-on', s === 1 || s === 2);
        if (pins.thigh) pins.thigh.classList.toggle('is-on', s === 2);
        if (pins.knee) pins.knee.classList.toggle('is-cool', s === 3);
        if (badges[1]) badges[1].classList.toggle('is-on', s === 1 || s === 2);
        if (badges[2]) badges[2].classList.toggle('is-on', s === 2);
      }

      /* ---------- loading ---------- */
      var queue = []; for (var i = 0; i < N; i++) queue.push(i);
      function pump() { while (active < 6 && queue.length) fetchOne(queue.shift()); }
      function fetchOne(i) {
        active++;
        var im = new Image(), done = false;
        function fin(ok) {
          if (done) return; done = true; active--;
          imgs[i] = ok ? im : null; loaded++;
          if (i === 0) { draw(); sync(); }
          if (loaded === N) setReady();
          pump();
        }
        im.onload = function () {
          if (!im.decode) return fin(true);
          var t = setTimeout(function () { fin(true); }, 1500);
          im.decode().then(function () { clearTimeout(t); fin(true); }, function () { clearTimeout(t); fin(true); });
        };
        im.onerror = function () { fin(false); };
        im.src = URLS[i];
      }
      function load() {
        if (started) return; started = true;
        timer = setTimeout(setReady, 8000);
        pump();
      }
      function setReady() {
        if (ready || !nearest(0)) return;
        ready = true; clearTimeout(timer);
        if (reduce) { p = HOLD; draw(); sync(); return; }
        kick();
      }

      /* ---------- loop ---------- */
      function kick() { if (!raf && visible && ready && !reduce) { last = 0; raf = requestAnimationFrame(frame); } }
      function frame(ts) {
        raf = 0; if (!visible || !ready) return;
        if (!last) last = ts;
        var dt = clamp(ts - last, 0, 100); last = ts;
        if (holdLeft > 0) {
          holdLeft -= dt;
          if (holdLeft <= 0 && atEnd) { p = 0; atEnd = false; passedHold = false; holdLeft = 500; }   /* start the loop again from the flat brace */
        } else {
          p += dt / DUR[clamp(Math.floor(p), 0, N - 2)];
          if (!passedHold && p >= HOLD) { p = HOLD; passedHold = true; holdLeft = DWELL; }
          if (p >= LAST) { p = LAST; atEnd = true; holdLeft = REST; }
        }
        draw(); sync();
        raf = requestAnimationFrame(frame);
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es, o) { if (es[es.length - 1].isIntersecting) { load(); o.disconnect(); } }, { rootMargin: '500px 0px' }).observe(clip);
        new IntersectionObserver(function (es) { visible = es[es.length - 1].isIntersecting; if (visible) kick(); }, { threshold: 0.2 }).observe(clip);
      } else { visible = true; load(); }
      sync();
    }

    function init(root) {
      if (root.__rxo) return; root.__rxo = true;
      overlay(root); player(root);
    }
    function boot(scope) { [].forEach.call((scope || document).querySelectorAll('[data-rxo]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-pdp"]) return;
  try {
    
  (function(){
    function init(root){
      var track = root.querySelector('[data-track]');
      var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
      var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
      var count = root.querySelector('[data-count]');
      var prevB = root.querySelector('[data-prev]');
      var nextB = root.querySelector('[data-next]');
      var cur = 0, lock = 0;
      function width(){ return track.clientWidth || 1; }
      function ends(){
        if (prevB) prevB.disabled = cur === 0;
        if (nextB) nextB.disabled = cur === slides.length - 1;
      }
      function mark(i){
        cur = i;
        thumbs.forEach(function(t, k){
          t.classList.toggle('is-on', k === i);
          if (k === i) {
            t.setAttribute('aria-current', 'true');
            var ul = t.parentNode.parentNode;
            if (ul && ul.scrollTo) ul.scrollTo({ left: Math.max(0, t.parentNode.offsetLeft - 24), behavior: 'smooth' });
          } else t.removeAttribute('aria-current');
        });
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        ends();
      }
      function go(i){
        i = Math.max(0, Math.min(slides.length - 1, i));
        lock = Date.now() + 500 + 160 * Math.abs(i - cur);
        track.scrollTo({ left: i * width(), behavior: 'smooth' });
        mark(i);
      }
      var raf = 0;
      track.addEventListener('scroll', function(){
        if (raf || Date.now() < lock) return;
        raf = requestAnimationFrame(function(){ raf = 0; var i = Math.round(track.scrollLeft / width()); if (i !== cur && i >= 0 && i < slides.length) mark(i); });
      }, { passive: true });
      thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(parseInt(t.getAttribute('data-thumb'), 10)); }); });
      if (prevB) prevB.addEventListener('click', function(){ go(cur - 1); });
      if (nextB) nextB.addEventListener('click', function(){ go(cur + 1); });
      track.addEventListener('keydown', function(e){ if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
      window.addEventListener('resize', function(){ if (track.scrollWidth > track.clientWidth + 2) track.scrollLeft = cur * width(); });
      ends();

      /* Set chooser: price, button and sticky bar follow the choice. */
      var radios = [].slice.call(root.querySelectorAll('.rxp__sets input[type="radio"]'));
      var price = root.querySelector('[data-price]');
      var main = root.querySelector('[data-main-add]');
      var bar = root.querySelector('[data-bar]');
      var barAdd = root.querySelector('[data-bar-add]');
      var barName = root.querySelector('[data-bar-name]');
      var barPrice = root.querySelector('[data-bar-price]');
      var note = root.querySelector('[data-note]');
      function apply(r){
        radios.forEach(function(x){ var o = x.closest('.rxp__opt'); if (o) o.classList.toggle('is-on', x === r); });
        var now = r.getAttribute('data-now'), was = r.getAttribute('data-was'), save = r.getAttribute('data-save');
        price.innerHTML = '<b>' + now + '</b>' + (was ? '<s>' + was + '</s>' : '') + (save ? '<span class="rx-badge rxp__save">' + save + '</span>' : '');
        main.setAttribute('data-rx-add', r.getAttribute('data-ids'));
        main.textContent = r.getAttribute('data-label') + ' · ' + now;
        barAdd.setAttribute('data-rx-add', r.getAttribute('data-ids'));
        barName.textContent = r.getAttribute('data-name');
        barPrice.textContent = now;
        if (note) note.hidden = r.value !== 'pair';
      }
      radios.forEach(function(r){ r.addEventListener('change', function(){ apply(r); }); });

      /* Sticky buy bar: after the main button scrolls away (desktop), or from the first scroll until it is back on screen (phones). */
      function bark(){
        var rc = main.getBoundingClientRect();
        var phone = window.innerWidth < 750;
        var on = rc.bottom < 0 || (phone && window.scrollY > 60 && rc.top > window.innerHeight - 24);
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        barAdd.tabIndex = on ? 0 : -1;
        document.documentElement.classList.toggle('has-rxbar', on);
        document.documentElement.style.setProperty('--rxbar-h', bar.offsetHeight + 'px');
      }
      window.addEventListener('scroll', bark, { passive: true });
      window.addEventListener('resize', bark);
      bark();
    }
    function boot(){ [].forEach.call(document.querySelectorAll('[data-rx-pdp]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-reel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      var row = root.querySelector('[data-row]');
      [].forEach.call(root.querySelectorAll('[data-dir]'), function(b){
        b.addEventListener('click', function(){
          var t = row.querySelector('.rxr__tile');
          var step = t ? t.getBoundingClientRect().width + 14 : 320;
          row.scrollBy({ left: step * parseInt(b.getAttribute('data-dir'), 10), behavior: 'smooth' });
        });
      });
    }
    function boot(){ [].forEach.call(document.querySelectorAll('[data-rx-reel]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-register"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var KEY = 'rxRegPending';
    function sendKlaviyo(p){
      try {
        var k = window.klaviyo;
        var profile = { email: p.email, first_name: p.first_name };
        var props = { 'Unit': p.unit, 'Bought At': p.bought_at, 'Order Number': p.order_number, 'Source Page': p.page, '$event_id': p.id };
        if (k && typeof k.identify === 'function' && typeof k.track === 'function') {
          k.identify(profile);
          k.track(p.event, props);
        } else if (k && typeof k.push === 'function') {
          k.push(['identify', profile]);
          k.push(['track', p.event, props]);
        }
      } catch (err) {}
    }
    function boot(root){
      var form = root.querySelector('form');
      if (!form || form.getAttribute('data-rx-reg') === '1') return;
      form.setAttribute('data-rx-reg', '1');
      /* After a successful registration the page reloads with the thank-you message. Send the saved registration once more here; Klaviyo ignores the repeat because it carries the same event ID. */
      if (root.querySelector('.rx-reg__ok')) {
        try {
          var raw = sessionStorage.getItem(KEY);
          if (raw) { sessionStorage.removeItem(KEY); sendKlaviyo(JSON.parse(raw)); }
        } catch (err) {}
        return;
      }
      var evt = root.getAttribute('data-event') || 'Registered Device';
      form.addEventListener('submit', function(){
        if (form.checkValidity && !form.checkValidity()) return;
        function g(n){ var el = form.elements[n]; return el ? String(el.value || '').trim() : ''; }
        var p = {
          id: 'reg-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8),
          event: evt,
          email: g('contact[email]'),
          first_name: g('contact[name]'),
          unit: g('contact[Unit]'),
          bought_at: g('contact[Bought at]'),
          order_number: g('contact[Order number]'),
          page: location.pathname
        };
        if (!p.email) return;
        try { sessionStorage.setItem(KEY, JSON.stringify(p)); } catch (err) {}
        sendKlaviyo(p);
      });
    }
    function init(){ [].forEach.call(document.querySelectorAll('[data-rx-register]'), boot); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rx-steps"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var phone = window.matchMedia('(max-width: 749px)');
    var PIN_ON_PHONE = false; /* true = page scroll drives the row on phones; false = plain swipe */
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    function init(sec){
      var track = sec.querySelector('[data-track]');
      var pin = sec.querySelector('[data-pin]');
      var row = sec.querySelector('[data-row]');
      if (!track || !pin || !row) return;
      var cards = [].slice.call(row.children);
      var dots = [].slice.call(sec.querySelectorAll('[data-go]'));
      var n = cards.length;
      if (n < 2) return;
      if (!window.CSS || !CSS.supports || !CSS.supports('position', 'sticky')) return;
      var on = false, last = -1, topOff = 8, total = 0, pitchPx = 316;

      function mark(i){
        if (i === last) return;
        last = i;
        cards.forEach(function(c, k){ c.classList.toggle('is-active', k === i); });
        dots.forEach(function(d, k){ d.classList.toggle('is-active', k === i); if (k === i) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current'); });
      }
      function measure(){
        track.style.setProperty('--pin-h', pin.offsetHeight + 'px');
        topOff = parseFloat(getComputedStyle(pin).top) || 0;
        total = track.offsetHeight - pin.offsetHeight;
        pitchPx = cards[0].offsetWidth + (parseFloat(getComputedStyle(row).columnGap) || 16);
      }
      function update(){
        if (!on) return;
        var p = total > 0 ? (topOff - track.getBoundingClientRect().top) / total : 0;
        p = Math.min(1, Math.max(0, p));
        row.scrollLeft = p * (n - 1) * pitchPx;
        mark(Math.round(p * (n - 1)));
      }
      function enable(){
        on = true; last = -1;
        sec.classList.add('is-pin');
        measure();
        update();
      }
      function disable(){
        on = false; last = -1;
        sec.classList.remove('is-pin');
        track.style.removeProperty('--pin-h');
        row.scrollLeft = 0;
        mark(0);
      }
      function sync(){
        if (PIN_ON_PHONE && phone.matches && !calm.matches) { if (!on) enable(); else { measure(); update(); } }
        else if (on) disable();
      }

      dots.forEach(function(d){
        d.addEventListener('click', function(){
          var i = parseInt(d.getAttribute('data-go'), 10) || 0;
          if (on) {
            var y = window.scrollY + track.getBoundingClientRect().top - topOff + (i / (n - 1)) * total;
            window.scrollTo({ top: y, behavior: 'smooth' });
          } else {
            row.scrollTo({ left: i * (cards[0].offsetWidth + 16), behavior: 'smooth' });
          }
        });
      });
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', sync);
      window.addEventListener('orientationchange', sync);
      if (phone.addEventListener) { phone.addEventListener('change', sync); calm.addEventListener('change', sync); }
      if ('ResizeObserver' in window) new ResizeObserver(function(){ if (on) { measure(); update(); } }).observe(pin);
      /* Dots also follow a plain swipe when the page is not driving the row. */
      row.addEventListener('scroll', function(){ if (!on) mark(Math.min(n - 1, Math.round(row.scrollLeft / (cards[0].offsetWidth + 16)))); }, { passive: true });
      sync();
    }
    function boot(){ [].forEach.call(document.querySelectorAll('[data-rx-steps]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
